<template>
  <div class="page-content">
    <div class="content-wrapper">
      <div class="row mr-0 ml-0 flex-1">
        <div class="col-12 col-md-9 pr-0 pl-0 d-flex flex-column justify-content-between flex-1">
          <div class="page-header bg-white mb-1">
            <div class="page-header-content header-elements-md-inline">
              <div class="page-title d-flex">
                <h4 class="font-weight-semibold">Data Export</h4>
              </div>
              <div class="d-flex"></div>
            </div>
          </div>

          <div v-if="isAdmin" class="mb-1 bg-white flex-1">
            <div class="card-body">
              <div class="row">
                <div class="col-12 col-md-6">
                  <h5>Export Detail</h5>
                  <div class="row">
                    <div class="col-12">
                      <div class="form-group">
                        <label for="">Filename : </label>
                        <input type="text" v-model="filename" class="form-control" placeholder="Filename" />
                      </div>
                      <div class="form-group">
                        <label for="">Date : </label>
                        <date-picker range class="w-100" v-model="dateRange" value-type="YYYY-MM-DD"
                          format="D MMM YYYY"></date-picker>
                      </div>
                      <!-- <div class="form-group">
                        <input
                          type="checkbox"
                          v-model="isOriginOnly"
                          id="isOriginOnly"
                        />
                        <label for="isOriginOnly" class="ml-1"
                          >Origin Only
                        </label>
                      </div> -->
                    </div>
                  </div>
                  <span class="fw-500">Data column</span>
                  <div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="export-column" value="custom"
                        id="custom-export" v-model="exportColumn" />
                      <label class="form-check-label" for="custom-export"> Custom </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="export-column" value="all" id="custom-column"
                        v-model="exportColumn" />
                      <label class="form-check-label" for="custom-column"> All columns </label>
                    </div>
                  </div>
                </div>
                <!-- <div class="col-4">
                  <div class="p-2" v-if="categoriesOptions.length">
                    <h5>Chunk Filter</h5>
                    <div class="form-group">
                      <label for="categories">Categories</label>
                      <Multiselect
                        id="categories"
                        v-model="categories"
                        :options="categoriesOptions"
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :preserve-search="true"
                        placeholder="Pick categories"
                      ></Multiselect>
                    </div>
                  </div>
                </div> -->
                <div class="col-12 col-md-3">
                  <h5>File Advance Filter</h5>
                  <label>File Status</label>
                  <div class="d-flex justify-content-between"><label @click="chunkStatus = chunkStatusOpts"
                      class="text-primary cursor-pointer">Select All</label><label @click="chunkStatus = []"
                      class="text-secondary cursor-pointer">Clear</label></div>
                  <Multiselect v-model="chunkStatus" :options="chunkStatusOpts" :multiple="true"
                    :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Choose...">
                  </Multiselect>

                </div>
                <div class="col-12 col-md-3">
                  <h5>Record Advance Filter</h5>
                  <div v-for="(filter, i) in filters" :key="i" class="mb-2">
                    <div class="mb-2">
                      <label>Data column
                        <a href="#" class="text-danger" @click.prevent.stop="
                          filters = filters.filter((v, index) => i !== index)
                          ">remove</a></label>
                      <select class="form-control" v-model="filter.col_key" @change="prepareValue(i)">
                        <option value="">Choose column name...</option>
                        <option :key="col.col_key" :value="col.col_key" v-for="col in columns">
                          {{ col.col_key }}
                        </option>
                      </select>
                    </div>
                    <div class="mb-2">
                      <select class="form-control" v-model="filter.operator">
                        <option value="">Choose condition...</option>
                        <option value="$in">Equal</option>
                        <option value="$nin">Not equal</option>
                      </select>
                    </div>

                    <div class="mb-2">
                      <div v-if="filter.data && filter.data.length">
                        <div class="d-flex justify-content-between"><label @click="filter.value = filter.data"
                            class="text-primary cursor-pointer">Select All</label><label @click="filter.value = []"
                            class="text-secondary cursor-pointer">Clear</label></div>
                        <Multiselect v-model="filter.value" :options="filter.data" :multiple="true"
                          :close-on-select="false" :clear-on-select="false" :preserve-search="true"
                          placeholder="Choose..."></Multiselect>

                      </div>
                      <input v-else type="text" class="form-control" placeholder="Value" v-model="filter.value" />
                    </div>
                  </div>
                  <a href="#" @click.prevent.stop="
                    filters.push({ col_key: '', operator: '', value: [] })
                    ">+ Add another data column</a>
                </div>
              </div>
              <div class="text-right mb-0 bg-white border-0">
                <button class="btn btn-primary" @click="exportData">
                  Export
                </button>
              </div>
            </div>
          </div>
          <!-- <SplitCategory></SplitCategory> -->
        </div>
        <div class="col-12 col-md-3  p-3">
          <h4 class="font-weight-semibold">Export history</h4>
          <div class="d-flex flex-row justify-content-between p-1" style="
              border-bottom: 1px;
              border-bottom-style: solid;
              border-bottom-color: #e8e8e8;
            " v-for="item in history" :key="item._id">
            <div>{{ item.filename }}</div>
            <div>
              <a :href="item.status === 'generating' ? null : item.link" target="_blank" class="p-1"
                @click.prevent="downloadExportFile(item)">
                <i :class="exportIcon(item.status)"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
// import SplitCategory from './SplitCategory.vue'
import Multiselect from 'vue-multiselect'
import serviceRoutes from '../../service-routes'
export default {
  data() {
    return {
      dateRange: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
      filename: null,
      columns: [],
      filters: [
        {
          col_key: 'record_status',
          operator: '$in',
          value: ['Read'],
          data: ['New', 'Read', 'Not sure', 'Delete']
        }
      ],
      interval: null,
      isOriginOnly: true,
      categories: [],
      categoriesOptions: [],
      chunkStatusOpts: ['New', 'To do', 'In progress', 'To review', 'In review', 'Reject', 'Done'],
      chunks: [],
      exportColumn: 'custom',
      chunkStatus: ['Done', 'To review', 'In review'],
      sentimentOpts: ['Positive', 'Neutral', 'Negative'],
      sentiment: []
    }
  },
  computed: {
    ...mapGetters({
      role: 'role',
      accountId: 'accountId',
      history: 'exportHistoryData'
    }),
    isAdmin() {
      return this.role === 'admin'
    }
  },
  mounted() {
    this.getRecordChunkByDate()
    this.getAccountConfigInit()
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  watch: {
    dateRange: function (newValue) {
      this.getRecordChunkByDate()
    }
  },
  methods: {
    ...mapActions({
      exportByDate: 'exportByDate',
      getExportHistory: 'getExportHistory',
      getAccountConfig: 'getAccountConfig'
    }),
    async exportData() {
      if (!this.dateRange[0] || !this.dateRange[1]) return

      let start = moment(this.dateRange[0]).startOf('day').valueOf()
      let end = moment(this.dateRange[1]).endOf('day').valueOf()
      this.$swal({
        toast: true,
        position: 'top-end',
        icon: 'info',
        title: 'Exporting...',
        showConfirmButton: false,
        showCloseButton: true
      })
      let condition = this.getFilter()
      await this.exportByDate({
        configId: this.accountId,
        start: start,
        end: end,
        filename: this.filename,
        condition,
        isOriginOnly: this.isOriginOnly,
        categories: this.categories,
        exportColumn: this.exportColumn,
        chunkStatus: this.chunkStatus,
        sentiment: this.sentiment
      })
      // if (response.error) {
      //   this.$swal({
      //     toast: true,
      //     position: 'top-end',
      //     icon: 'error',
      //     title: 'Something went wrong',
      //     text: response.message,
      //     showConfirmButton: false,
      //     showCloseButton: true })
      // }
    },
    getFilter() {
      let filters = this.filters.filter((v) => v.col_key.length)
      let filter = {}
      for (let condition of filters) {
        if (condition.col_key && condition.operator && condition.value) {
          filter[condition.col_key] = {}
          let colType = this.columns.filter(
            (v) => v.col_key === condition.col_key
          )[0].col_type
          let value = condition.value
          if (colType === 'boolean') {
            value = Boolean(condition.value)
          }
          filter[condition.col_key][condition.operator] = Array.isArray(value)
            ? value
            : [value]
        }
      }
      return filter
    },
    exportIcon(status) {
      let icon = 'far fa-circle text-grey-300'
      if (status === 'generating') {
        icon = 'icon-spinner2 spinner text-teal-400'
      }
      if (['generated', 'downloaded'].includes(status)) {
        icon = 'fas fa-download text-teal-400'
      }
      return icon
    },
    async getAccountConfigInit() {
      let account = await this.getAccountConfig()
      let columnFilters = account.showColumns || []
      columnFilters = columnFilters.filter((v) => v.col_key !== 'is_incident')
      columnFilters.push({
        col_key: 'is_incident',
        col_type: 'boolean',
        col_header: 'is_incident'
      })
      columnFilters.push(
        {
          col_key: 'sentiment',
          operator: '$in',
          value: [],
          data: ['positive', 'negative', 'neutral']
        })
      this.columns = columnFilters
    },
    prepareValue(idx) {
      let colKey = this.filters[idx].col_key
      let values = this.columns.filter((v, i) => v.col_key === colKey)[0].data
      this.filters[idx].data = values
      this.filters[idx].value = Array.isArray(values) ? [] : undefined
    },
    getRecordChunkByDate() {
      serviceRoutes
        .searchRecordChunkByDate(
          moment(this.dateRange[0]).valueOf(),
          moment(this.dateRange[1]).valueOf()
        )
        .then((res) => {
          // this.chunks = res.data.data.map(chunk => {
          //   return {
          //     ...chunk,
          //     filename: moment(chunk.endDate).format('DD MMM') + ' ' + chunk.filename + (chunk.criteria && chunk.criteria.category ? ` - ${chunk.criteria.category[0]}` : '')
          //   }
          // })
          this.categoriesOptions = res.data.categories
        })
    },
    async downloadExportFile(item) {
      if (['generated', 'downloaded'].includes(item.status)) {
        serviceRoutes.downloadExportFile(item._id).catch(error => {
          if (error.response.status === 404) {
            this.$swal({
              toast: true,
              position: 'top-end',
              icon: 'error',
              title: 'File not found',
              showConfirmButton: false,
              showCloseButton: false
            })
          }
        })
      }
    }
  },
  components: { Multiselect }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
